import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import {
  Export,
  ExportsResponse,
  GenerateExportRequest,
  GenerateExportResponse,
} from '@shared/export/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({ providedIn: 'root' })
export class ExportDataService {
  private readonly basePath = '/v.1/export';

  constructor(private readonly http: ApiClientService) { }

  getExports(): Observable<Export[]> {
    return this.http.get<ExportsResponse>(this.basePath).pipe(
      map(({success, data, error}) => {
        if(success) {
          return data;
        } else {
          throw new Error(`${error}`);
        }
      })
    );
  }

  setExport(options: GenerateExportRequest): Observable<string> {
    return this.http.post<GenerateExportResponse>(this.basePath, options).pipe(
      map(({success, data, error}) => {
        if(success) {
          return data;
        } else {
          throw (`${error}`);
        }
      })
    );
  }
}
